import { TextField, Typography } from "@mui/material";
import { TextFieldStyles } from "../../../styles/commonStyles";
import { FORM_CONSTANTS } from "./genericInfoFormUtils";

const BasicInfo = ({
  isEditMode,
  theme,
  errors,
  register,
  initialData,
  fieldName,
  fieldType,
  irrigationSystem,
  memoizedFieldTypes,
  memoizedIrrigationTypes,
}) => {
  return (
    <>
      <Typography fontWeight="bold" fontSize="16px">
        Info generali
      </Typography>
      <Typography fontSize="14px" color={theme.palette.custom.infoTextColor}>
        {isEditMode
          ? FORM_CONSTANTS.DESCRIPTIONS.EDIT
          : FORM_CONSTANTS.DESCRIPTIONS.CREATE}
      </Typography>
      <TextField
        variant="filled"
        sx={TextFieldStyles}
        label="Nome terreno*"
        InputLabelProps={{ shrink: Boolean(fieldName) || undefined }}
        aria-describedby={errors?.name ? "fieldName-error" : null}
        {...register("name", {
          required: "Nome terreno obbligatorio",
        })}
        error={!!errors?.name}
        helperText={errors?.name?.message}
      />
      <TextField
        variant="filled"
        select
        defaultValue={
          initialData?.field_type?.id || initialData?.field_type || ""
        }
        sx={TextFieldStyles}
        label="Tipologia terreno*"
        InputLabelProps={{ shrink: Boolean(fieldType) || undefined }}
        {...register("field_type", {
          required: "Tipologia terreno obbligatoria",
        })}
        error={!!errors?.field_type}
        helperText={errors?.field_type?.message}
      >
        {memoizedFieldTypes}
      </TextField>
      <TextField
        variant="filled"
        select
        defaultValue={
          initialData?.irrigation_system?.id ||
          initialData?.irrigation_system ||
          ""
        }
        sx={TextFieldStyles}
        label="Tipologia irrigazione"
        InputLabelProps={{ shrink: Boolean(irrigationSystem) || undefined }}
        {...register("irrigation_system")}
      >
        {memoizedIrrigationTypes}
      </TextField>
    </>
  );
};

export default BasicInfo;
